module.exports = __webpack_public_path__ + "site/img/20.b670b433.jpg";